/*

THIS IS THE MAIN APP CONTAINER THAT WILL CONTAIN THE 3 PRIMARY COMPONENTS
- APP HEADER (LOGO AND COLORS)
- APP CONTENT (THE DYNAMIC CONTENT)
- APP FOOTER (PRIVACY POLICY ETC)

*/

import React, { useEffect, useState, useRef } from 'react';
import './AppContainer.css';
import AppHeader from '../AppHeader/AppHeader';
import Stepper from '../Stepper/Stepper';
import AppContent from '../AppContent/AppContent';
import AppFooter from '../AppFooter/AppFooter';
import ThankYouContainer from '../ThankYouV2/ThankYouContainer';
import LeftPanel from '../LeftPanel/LeftPanel';
import { useDispatch, useSelector } from 'react-redux';
import { setCart, setFrontConfig, setLoading, setCheckoutStep, setUrlParams } from '../../actions/actionCreators';
import CartService from '../../services/CartService'
import FrontConfig from '../../services/FrontConfigService'
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@material-ui/core';
import LanguageIcon from '@material-ui/icons/Language';
import { APP_TYPE, ZENPAY, SCHEDULER } from '../../constants/AppConstants';
import {
  useLocation,
  BrowserRouter as Router,
  Route,
  useParams,
  useRouteMatch,
  useHistory,
  Redirect,
} from "react-router-dom";

const queryString = require('query-string');

const AppContainer = () => {
  const matches = useMediaQuery("(max-width:599px)");
  const cart = useSelector(state => state.cartReducer);
  const checkoutStep = useSelector(state => state.navigationReducer.checkoutStep);
  const front_config = useSelector(state => state.frontConfigReducer);
  const navigation = useSelector(state => state.navigationReducer);
  const urlParams = useSelector(state => state.urlParamsReducer) || { token: 0 };
  const { search } = useLocation();
  const { source, token, host, pickupOnly, id, location_id } = queryString.parse(search);
  const [lang, setLang] = useState('English');
  const [appConfigLoaded, setAppConfigLoaded] = useState(false);
  const { t, i18n } = useTranslation();
  const zenPayToken = useParams();
  const dispatch = useDispatch();
  let { path, url } = useRouteMatch();
  let history = useHistory();

  useEffect(() => {
    if (APP_TYPE === SCHEDULER && source === 'pa') {
      // dispatch(setUrlParams({ source, token: '000J4NLRHgg71KoqnfNVRTA88I4xOicY', host, pickupOnly, id, location_id }));
      dispatch(setUrlParams({ source, token: '000J4NLRHgg71KoqnfNVRTA88I4xOicY', host, pickupOnly, id, location_id }));
    } else if (APP_TYPE === SCHEDULER) {
      dispatch(setUrlParams({ source, token, host, pickupOnly, id, location_id }));
    }
    if (APP_TYPE !== SCHEDULER) {
      data();
    }
    
  }, [])

  useEffect(() => {
    if (APP_TYPE === ZENPAY && checkoutStep === 4) {
      // history.push(`${url}/thank-you`);
      redirectToStoreHome();
    }
  }, [checkoutStep])

  useEffect(() => {
    if (APP_TYPE === SCHEDULER && urlParams.token !== '') {
      data()
    }
  }, [urlParams.token])

  const data = async () => {
    dispatch(setLoading(true));
    if (APP_TYPE === ZENPAY) {
      let responseCart = await CartService.cartData(zenPayToken.token);
      dispatch(setCart(responseCart));
      let responseFrontConfig = await FrontConfig.getData(zenPayToken.token);
      dispatch(setFrontConfig(responseFrontConfig));
      setAppConfigLoaded(true);
      if (responseCart.payment && responseCart.payment.option_code && responseCart.payment.option_code.length > 0) {
        dispatch(setCheckoutStep(4));
      }
      if (responseCart.language) {
        changeToLang(responseCart.language)
      }
    } else {
      let responseCart = await CartService.cartData(urlParams.token);
      dispatch(setCart(responseCart));
      let responseFrontConfig = await FrontConfig.getData(urlParams.token);
      dispatch(setFrontConfig(responseFrontConfig));
    }
    dispatch(setLoading(false));
  };

  const theme = createMuiTheme({
    palette: {
      primary: {
        light: front_config.color_light,
        main: front_config.color,
        dark: front_config.color,
      },
      secondary: {
        light: '#ffa502',
        main: '#ffa502',
        dark: '#ffa502',
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      {
        APP_TYPE === ZENPAY ?
          renderZenPay()
          :
          renderScheduler()
      }
    </ThemeProvider>
  )

  function renderZenPay() {
    if (checkoutStep !== 4) {
      return (
        <div className="AppContainer">
          <AppHeader />
          <AppContent appConfigLoaded={appConfigLoaded} />
          <AppFooter appConfigLoaded={appConfigLoaded} />
          <div className="ChangeLangBtn" onClick={changeLang}>
            <LanguageIcon style={{ fontSize: '1rem' }} />
            <p className="LanguageTxt">{lang}</p>
          </div>
        </div>
      )
    } else {
      return renderThankyouPage()

    }
  };

  function renderThankyouPage() {
    return (
      <Route path={`${path}/thank-you`}>
        {
          cart.payment?.option_code ?
            <div className="AppContainer">
              <AppHeader />
              <ThankYouContainer />
              <div className="ChangeLangBtn" onClick={changeLang}>
                <LanguageIcon style={{ fontSize: '1rem' }} />
                <p className="LanguageTxt">{lang}</p>
              </div>
            </div>
            :
            <Redirect to={`${url}`} />
        }
      </Route>
    )
  }

  function renderScheduler() {
    if (source === "shopify") {
      return (
        <LeftPanel source={source} />
      )
    } else {
      if (navigation.confirmationSuccess === false) {
        return (
          <div key={"1"} className="AppContainerScheduler">
            <AppHeader />
            <AppContent />
            <div className="ChangeLangBtn" onClick={changeLang}>
              <LanguageIcon style={{ fontSize: '1rem' }} />
              <p className="LanguageTxt">{lang}</p>
            </div>
          </div>
        )
      } else {
        return (
          <div key={"2"} className="AppContainer">
            <ThankYouContainer />
          </div>
        )
      }
    }
  }

  function changeLang() {
    if (lang === 'English') {
      setLang('François');
      i18n.changeLanguage('fr')
    } else {
      setLang('English');
      i18n.changeLanguage('en')
    }

  }

  function changeToLang(langCode) {
    if (langCode === 'fr') {
      setLang('François');
      i18n.changeLanguage('fr')
    } else {
      setLang('English');
      i18n.changeLanguage('en')
    }
  }

  function redirectToStoreHome() {
    let url = cart.language === 'fr' ? front_config.link_store_home + "pages/checkout-thank-you-fr?token=" + cart.token : front_config.link_store_home + "pages/checkout-thank-you?token=" + cart.token;
    window.location.href = url;
  }
}

export default AppContainer;
